module.exports = __webpack_public_path__ + "static/media/Banner(LuckyDraw).b15f02c6.jpg";